var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"element-input element-checkbox"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),_c('ul',_vm._l((_vm.items),function(item){return _c('li',{class:{
      on: _vm.isMultiple
        ? ( _vm.value.indexOf( item.value ) >= 0 )
        : _vm.value },on:{"click":function($event){return _vm.selectItem( item.value )}}},[_vm._v(_vm._s(item.label))])}),0),(_vm.error)?_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }